import { Component, Vue } from 'vue-property-decorator';
import { getComponentProps } from '@/utils/vueUtils';

import { ArticleTagsModuleViewModel } from './ArticleTagsModule.types';

import TagsComponent from '@/components/TagsComponent/TagsComponent.vue';

const ArticleTagsModuleProps = Vue.extend({
  props: getComponentProps<ArticleTagsModuleViewModel>({
    TagItems: [
      {
        Link: '#',
        Title: 'Wildlife & Nature',
      },
      {
        Link: '#',
        Title: 'South Pacific',
      },
      {
        Link: '#',
        Title: 'Alaska',
      },
      {
        Link: '#',
        Title: 'World View',
      },
      {
        Link: '#',
        Title: 'Culture',
      },
      {
        Link: '#',
        Title: 'Reading',
      },
    ],
  }),
});

@Component({
  components: { TagsComponent },
})
export default class ArticleTagsModule extends ArticleTagsModuleProps {}
